import React from 'react';

const UserAvatar = ({ name, role, size = 'md', className = '' }) => {
  // Get initials from name
  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  // Get background color based on role
  const getBackgroundColor = (userRole) => {
    switch (userRole) {
      case 'doctor':
        return 'bg-green-500'; // Vert pour les médecins
      case 'admin':
        return 'bg-purple-500'; // Violet pour les admins
      case 'patient':
      default:
        return 'bg-orange-500'; // Orange pour les patients
    }
  };

  // Get size classes
  const getSizeClasses = (avatarSize) => {
    switch (avatarSize) {
      case 'xs':
        return 'w-6 h-6 text-xs';
      case 'sm':
        return 'w-8 h-8 text-sm';
      case 'lg':
        return 'w-20 h-20 text-2xl';
      case 'xl':
        return 'w-24 h-24 text-3xl';
      case 'md':
      default:
        return 'w-10 h-10 text-base';
    }
  };

  const initials = getInitials(name);
  const bgColor = getBackgroundColor(role);
  const sizeClasses = getSizeClasses(size);

  return (
    <div
      className={`${sizeClasses} ${bgColor} rounded-full flex items-center justify-center text-white font-semibold shadow-md ${className}`}
      title={`${name} (${role === 'doctor' ? 'Médecin' : role === 'admin' ? 'Admin' : 'Patient'})`}
      data-testid="user-avatar"
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
